import { Col, Row } from 'reactstrap';

import Pims from './Pims';
import SyncDate from './SyncDate';
import AttachmentExtractionScheduling from './AttachmentExtractionScheduling';
import InstanceId from './InstanceId';
import ConfigHeader from './ConfigHeader';
import AssignmentAndMute from './AssignmentAndMute';
import PracticeOfferings from './PracticeOfferings';
import PracticeShards from './PracticeShards';
import FriendlyId from './FriendlyId';

const PracticeConfiguration = () => {
    return (
        <Row>
            <ConfigHeader />
            {/*
             * Shard information and offerings move to a second column when the panel is wide
             * enough for both, and stack beneath the first when it isn't. See
             * .sc-config-columns in PracticeOverview.css for how the collapse is triggered
             * and how to tune it.
             *
             * px-0 keeps the rows aligned exactly where they were before this wrapper existed
             * — the rows carry their own px-3, so any padding here would shift them right.
             */}
            <Col sm="12" className="sc-config-columns px-0">
                <div className="sc-config-column">
                    <InstanceId />
                    <FriendlyId />
                    <Pims />
                    <SyncDate />
                    <AttachmentExtractionScheduling />
                    <AssignmentAndMute />
                </div>
                <div className="sc-config-column">
                    <PracticeShards />
                    <PracticeOfferings />
                </div>
            </Col>
        </Row>
    );
};

export default PracticeConfiguration;
